import { FormControl, FormGroup, Validators } from '@angular/forms';
import { DomesticAddressFormModel } from './domestic-address-form.model';
import { AdresDomowy } from '../../../../models/adres';
import { SharedValidators } from '../../../../validators/shared-validators';

export class DomesticAddressFormBuilder {
  public static createFormGroup(
    address?: AdresDomowy,
  ): FormGroup<DomesticAddressFormModel> {
    return new FormGroup<DomesticAddressFormModel>({
      id: new FormControl(address?.id || null),
      gminaDzielnica: new FormControl(address?.gminaDzielnica || null, [
        Validators.required,
      ]),
      kodPocztowy: new FormControl(address?.kodPocztowy || null, [
        Validators.required,
        SharedValidators.doNotBeginWithWhitespace(),
      ]),
      poczta: new FormControl(address?.poczta || null, [
        Validators.required,
        SharedValidators.patternWithCustomMessage(
          /^[A-Za-zĄąĆćĘęŁłŃńÓóŚśŹźŻż\s]+(-[A-Za-zĄąĆćĘęŁłŃńÓóŚśŹźŻż\s]+)*$/,
          'incorrectPattern',
        ),
        SharedValidators.doNotBeginWithWhitespace(),
      ]),
      miejscowosc: new FormControl(address?.miejscowosc || null, [
        Validators.required,
      ]),
      ulica: new FormControl(address?.ulica || null),
      nrDomu: new FormControl(address?.nrDomu || null, [
        Validators.required,
        Validators.maxLength(10),
        SharedValidators.doNotBeginWithWhitespace(),
      ]),
      nrLokalu: new FormControl(address?.nrLokalu || null, [
        SharedValidators.doNotBeginWithWhitespace(),
        Validators.maxLength(10),
      ]),
    });
  }
}
